import calculo from "./calculo"

async function fetchDados(mesSelecionado, isAcumulado) {

    let metas = await getMetas();
    metas = calculo.formataMetas(metas);
    metas = calculo.calculaDados(metas)
    metas = calculo.calculaTotalDR(metas)

    let dados = Object.assign({}, metas);
    let acumulado = calculo.calculaAcumuladoMetas2(dados);

    // realizados
    let realizados = await getRealizados(isAcumulado);

    // Novo formato do JSON
    dados = calculo.novoJsonMetas(dados);
    realizados = calculo.novoJsonRealizados(realizados);
    acumulado = calculo.novoJsonMetas(acumulado)

    if(isAcumulado) {
        dados = [ ...acumulado ]
    }

    dados = dados.map((unidade, i) => {
        let index = realizados.findIndex((v) => v.unidade === unidade.unidade);
        let metas = calculo.usarMedida(unidade.metas);
        return { ...unidade, metas, realizados: realizados.length > 0 ? realizados[index]["metas"] : [] }
    });

    return { dados: dados, realizados: realizados };

}

async function getMetas() {
    let dados = await fetch(`${process.env.REACT_APP_API_URL}/consulta?tipo=metas`);
    dados = await dados.json();
    return dados.dados;
}

async function getRealizados(isAcumulado) {
    let tipo = isAcumulado ? "acumulado" : "mes";
    let realizados = await fetch(`${process.env.REACT_APP_API_URL}/consulta?tipo=${tipo}`);
    realizados = await realizados.json();
    return realizados.dados;
}

export default { fetchDados, todasAsModalidades: calculo.todasAsModalidades };
